import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const CompareAlert1ToMedicalGuardianPage: React.FC = () => {
  const { getImage } = useImages();
  const kitchenImage = getImage('PriceCompareImage-1.jpg');
  const whyChooseImage = getImage('3-Price-Compare-Mobile-Medical-Alert.jpg');
  const readyToTryImage = getImage('4-Price-Compare-Mobile-Medical-Alert-Wristband.jpg');

  return (
    <div className="compare-alert1-to-medical-guardian-page compare-alert1-to-life-alert-page">
      {/* Hero Section */}
      <section className="compare-hero-new">
        <div className="compare-hero-container">
          <div className="compare-hero-content">
            <h1>Medical Guardian Medical Alert System Alternatives: Try Alert-1</h1>
            
            <p className="compare-hero-text">
              For a medical alert system with affordable, flexible payment plans, a best in class customer monitoring center, trained emergency operators, best fall detection technology, longest battery life, and great value, then you've come to the right place.
            </p>
            
            <p className="compare-hero-text">
              We invite you to check out our Comparison Chart against a Medical Guardian System below. We're confident you'll find that Alert1 offers all the same features as Medical Guardian (and more) at a lower cost. The high value Alert1 deliver vs. Medical Guardian cost makes us the choice to provide protection and peace of mind for your loved ones.
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <Link to="/medical-alerts" className="btn btn-primary compare-hero-btn">
                VIEW SYSTEMS
              </Link>
            </div>
          </div>
          
          <div className="compare-hero-image">
            <div className="circular-image-wrapper">
              {kitchenImage ? (
                <img 
                  src={kitchenImage} 
                  alt="Grandmother and granddaughter baking" 
                  className="circular-image"
                />
              ) : (
                <div className="circular-image-placeholder" />
              )}
            </div>
            <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                Call <strong>1-877-573-4195</strong> today and
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                see why Alert1 is the best
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                medical alert system provider for
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                you or your loved one.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table Section */}
      <section className="comparison-section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, margin: '0', padding: '0', lineHeight: '1.1', display: 'block' }}>Alert1 and Medical Guardian</h2>
            <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, margin: '0', padding: '0', lineHeight: '1.1', display: 'block' }}>Medical Alert Systems Comparison</h2>
            <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, margin: '0', padding: '0', lineHeight: '1.1', display: 'block' }}>Chart</h2>
          </div>
          
          <p style={{ textAlign: 'center', fontSize: '1.15rem', lineHeight: '1.7', color: '#333', marginBottom: '2rem', maxWidth: '900px', margin: '0 auto 2rem auto' }}>
            See for yourself then call for special offer! Alert1 has the most affordable{' '}
            <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>medical alert devices</Link>
            {' '}for seniors. If you've been reviewing Medical Guardian or any other medical alert provider, we're confident you'll find that Alert1 provides stellar service at a great value. Compare our personal emergency alarm services to Medical Guardian and see how much Alert1 can do for you.
          </p>
          
          <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>Alert1 vs Medical Guardian Costs At a Glance</h2>
          <p className="section-subtitle">
            See how Alert1 compares to Medical Guardian on pricing and terms.
          </p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="highlight-col">Alert1</th>
                  <th>Medical Guardian</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Prices Starting At</strong>
                    <br />
                    <Link to="/pricing" style={{ fontSize: '0.9rem', color: '#0066cc', textDecoration: 'underline' }}>See Pricing</Link>
                  </td>
                  <td className="highlight-col">$19.95/mo<sup>1</sup></td>
                  <td>$29.95/mo<sup>2</sup></td>
                </tr>
                <tr>
                  <td><strong>No Long-Term Contract Required</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Nationwide Coverage</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>UL Listed</strong><br /><small>Monitoring center</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>BBB Accredited Business</strong><br /><small>A+ rating from the Better Business Bureau</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Unknown</td>
                </tr>
                <tr>
                  <td><strong>Constant Care</strong><br /><small>We stay on the phone until help arrives</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Multilingual Protection</strong><br /><small>Responders speak 190 different languages</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Same Day Shipping</strong><br /><small>For 85% or more of orders</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Free Use of Equipment</strong><br /><small>On most devices</small></td>
                  <td className="highlight-col">✓</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td><strong>Thayer Certified</strong><br /><small>Safe, fair working environment</small></td>
                  <td className="highlight-col">✓</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td><strong>TMA Five Diamond Certified Monitoring Center</strong><br /><small>Ensures that each center meets only the highest standards</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Modern Senior Magazine<sup>*</sup></strong><br /><small>#1 Rated Medical Alert System</small></td>
                  <td className="highlight-col">✓</td>
                  <td>No</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-footnote">
            <sup>1</sup>Disclaimer: All information, prices, and data was last verified in December 2022. 
            To report any incorrect or outdated information, please get in touch with us. For more information 
            on Alert1's features and costs, check out our <Link to="/pricing">pricing page</Link>.
          </div>
        </div>
      </section>

      {/* About Medical Guardian Section */}
      <section className="alternative-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <h2>About Medical Guardian Personal Emergency Response Systems</h2>
          
          <p className="section-intro">
            Medical Guardian is a leading provider of personal emergency response systems founded in 2005 by Geoff Gross in Philadelphia.
          </p>

          <div style={{ maxWidth: '900px', margin: '2rem auto' }}>
            <h3 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333', marginTop: '2rem', marginBottom: '1rem' }}>Medical Guardian Safety & Monitoring</h3>
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem' }}>
              <li>Medical Guardian uses trained emergency operators at Medical Guardian's monitoring center.</li>
              <li>Medical Guardian provides comprehensive monitoring services.</li>
            </ul>

            <h3 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333', marginTop: '2rem', marginBottom: '1rem' }}>Medical Guardian Product Features</h3>
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem' }}>
              <li>Medical Guardian offers options for both stay-at-home and on the go medical alert systems for active seniors and medical alert devices designed for different mobility needs.</li>
              <li>Medical Guardian utilizes cellular network technology for consistent connectivity for mobile medical alert devices. Notable devices include wearable mobile devices like the MGMini (water-resistant with 5-day battery life).</li>
              <li>Medical Guardian products have fall detection technology available and they use modern accurate fall detection technology using 6-axis sensors.</li>
              <li>Medical Guardian offers in-home systems with the furthest signal range (up to 1,300 feet).</li>
              <li>Medical Guardian has voice activated wall buttons for hands-free emergency calls.</li>
            </ul>

            <h3 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333', marginTop: '2rem', marginBottom: '1rem' }}>Medical Guardian Support & Resources</h3>
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem' }}>
              <li>There are detailed Medical Guardian FAQ sections on their website answering common questions. Safety information portal on Medical Guardian website through the MyGuardian app and desktop interface</li>
              <li>The company offers a free 2-minute assessment for those at high risk of falls. You may complete medical guardian system components explained clearly.</li>
              <li>You can shop medical alert systems from Medical Guardian online or call them for fall detection specials called daylight extra deals, or other options.</li>
            </ul>

            <h3 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333', marginTop: '2rem', marginBottom: '1rem' }}>Medical Guardian Customer Experience</h3>
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem' }}>
              <li>Medical Guardian features impressive life saving story testimonials from real users</li>
              <li>Various Medical guardian plans have with no contracts or hidden fees</li>
            </ul>
          </div>

          <div className="cta-center" style={{ marginTop: '3rem' }}>
            <Link to="/medical-alerts" className="btn btn-primary">TRY US TODAY</Link>
          </div>
        </div>
      </section>

      {/* Why Choose Alert1 Section */}
      <section className="alternative-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <div className="value-content-wrapper">
            <div className="value-image">
              <div className="circular-image-wrapper">
                {whyChooseImage ? (
                  <img 
                    src={whyChooseImage} 
                    alt="Woman with medical alert pendant" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <h2>Why Choose Alert1?</h2>
            
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem', maxWidth: '900px' }}>
              <li>Unlike other medical alert providers, Alert1's emergency responders stay on the line with you until appropriate help is secured, so you will never face an emergency alone.</li>
              <li>Help buttons can be worn as a pendant or wristband and are small, lightweight, and discreet.</li>
              <li>100% showerproof help buttons and can be worn anywhere, even in the bath or in inclement weather conditions.</li>
              <li>Alert1 medical alert systems are easy to set up and operate—just plug in and go.</li>
              <li>Every Alert1 home system comes with a backup battery and will automatically notify you if your console or help button battery is low.</li>
              <li>Highly trained emergency response operators are immediately available with the push of a button.</li>
              <li>In-home systems afford a 600 ft. range around the base unit for excellent coverage throughout your home.</li>
              <li>Mobile systems have an unlimited range from coast to coast and give you the ability to call for help anywhere you go.</li>
              <li>Unlimited button pushes mean you will never be charged additional fees for frequent usage.</li>
              <li>Optional fall detection technology is available and encouraged, to supply the greatest level of protection for you or your loved ones.</li>
              <li>Flexible payment plans mean you're in control—pay month to month or pay annually in advance for the greatest discounts.</li>
            </ul>
          </div>
          
          <div style={{ marginTop: '2rem', clear: 'both', maxWidth: '900px' }}>
            <p className="section-intro" style={{ marginBottom: '1rem', textAlign: 'left' }}>
              In addition to securing assistance fast in the event of a frightening or disorienting medical emergency, you can also use your Alert1 medical alert device as a home security emergency button alarm. Our systems are also useful when you need to get in touch with a friend or family member for assistance and you don't want to call 911.
            </p>
            
            <p className="section-intro" style={{ marginBottom: '2rem', textAlign: 'left' }}>
              If you are someone who wants to maintain your independence and has an eye for safety and practicality, Alert1 has the medical alert system for you. Contact us for more information and to start protecting yourself today. Our prices are lower than Medical Guardian costs, and we have a system for every budget, need, and lifestyle.
            </p>
          </div>
          
          <div className="cta-center">
            <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
          </div>
        </div>
      </section>

      {/* Ready to Try Alert1 Section */}
      <section className="alternative-section" style={{ background: 'white' }}>
        <div className="container">
          <h2>Ready to Try Alert1?</h2>
          
          <div style={{ display: 'flex', gap: '3rem', marginTop: '3rem', alignItems: 'flex-start' }}>
            <div style={{ flexShrink: 0 }}>
              <div className="circular-image-wrapper">
                {readyToTryImage ? (
                  <img 
                    src={readyToTryImage} 
                    alt="Elderly couple" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <div style={{ flex: 1 }}>
              <p className="section-intro">
                Why pay more for Medical Guardian? We invite you or your loved one to be our next valued member!
              </p>
              
              <p className="section-intro">
                Simply order your new medical alert service{' '}
                <Link to="/medical-alerts" style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#333' }}>right here</Link>
                {' '}on our website, or call one of our New Member Specialists who will be happy to answer any questions and get you started. It's time to enjoy the security, protection, and peace of mind you'll get from your new personal alarm button.
              </p>
              
              <p className="section-intro">
                We'll ship your new medical alert system to you using FedEx Express 2 Day Shipping. Most of our orders are shipped out on the same day the order is <strong>placed</strong>.
              </p>
              
              <p className="section-intro" style={{ marginBottom: '2rem' }}>
                When it comes to benefits and overall value, no other medical alert system provider compares to Alert1!
              </p>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
          </div>
        </div>
      </section>

      {/* Footnotes Section */}
      <section className="alternative-section" style={{ background: 'white' }}>
        <div className="container">
          <div className="table-footnote" style={{ marginTop: '2rem' }}>
            <p>*Pricing of Alert1 annual service plans. Monthly fee depends on system and options selected. Pricing is based on standard rates, temporary promotions may apply, offers subject to change.</p>
            <p>Medical Guardian website accessed on 12/29/2022. Copyright © Medical Guardian, LLP ©. All Rights Reserved.</p>
            <p>Alert1 does not require long term contracts. Any user may cancel service at any time, simply by returning the Alert1 equipment. However, some users agree to contracts of a specified length (for example, annual plans) in exchange for a substantial discount. Such users may cancel their service early, but Alert1 does not offer refunds in such circumstances unless the user has passed away or moved into a certified nursing home or assisted living facility where Alert1 service is no longer supported or allowed.</p>
            <p>Medical alert comparisons and pricing are based on standard rates, temporary promotions may apply, offers subject to change. View our competitive advertising guidelines.</p>
            <p>If you would like to request any changes to the information provided here, contact <a href="mailto:marketing@alert1.com" style={{ color: '#0066cc', textDecoration: 'underline' }}>marketing@alert1.com</a></p>
            <p>*Alert1 and Modern Senior Magazine are wholly owned by ResponseLINK, LLC.</p>
            <p>Please note that for all comparisons a lack of a check mark indicates that the competitor criteria is not listed on the competitor's official website.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompareAlert1ToMedicalGuardianPage;
